module.exports = __webpack_public_path__ + "static/media/19ESCAP48.c85e6812.jpg";